module.exports = __webpack_public_path__ + "g.no2.8c167f2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/g.no2.jpg
// module id = IX7k
// module chunks = 0